import axios from "axios";


// Degree/Qualification (static)
export const qualifications = [
'SSLC / 10th',
  'HSC / 12th',
  'Diploma',
  "Bachelor's Degree",
  "Master's Degree",
  'Doctorate / PhD',
  'Professional Degree (MBBS, LLB, CA, etc.)',
  'Others',
];

// Others options (classes 1st to 9th and 11th)
export const othersOptions = [
  '1st Std (I)',
  '2nd Std (II)',
  '3rd Std (III)',
  '4th Std (IV)',
  '5th Std (V)',
  '6th Std (VI)',
  '7th Std (VII)',
  '8th Std (VIII)',
  '9th Std (IX)',
  '11th Std (XI)',
];

// Education Type (static)
export const educationTypes = [
  "Regular",
  "Full-time",
  "Part-time",
  "Distance Learning",
  "Online/E-Learning",
  "Other",
];

// Institute/School (static)
export const instituteSchools = [
  "Govt School",
  "Private School",
  "College",
  "Other",
];

// Boards (static, as no free API available)
export const schoolBoards = [
  // 🏛 National Boards
  'CBSE (Central Board of Secondary Education)',
  'ICSE (Indian Certificate of Secondary Education)',
  'NIOS (National Institute of Open Schooling)',

  // 📚 State Boards
  'Tamil Nadu State Board',
  'Kerala State Board',
  'Andhra Pradesh Board of Secondary Education',
  'Telangana State Board of Intermediate Education',
  'Maharashtra State Board of Secondary & Higher Secondary Education',
  'Gujarat Secondary and Higher Secondary Education Board',
  'Rajasthan Board of Secondary Education',
  'Punjab School Education Board',
  'Haryana Board of School Education',
  'Uttar Pradesh Board of High School and Intermediate Education',
  'Bihar School Examination Board',
  'West Bengal Board of Secondary Education',
  'Madhya Pradesh Board of Secondary Education',
  'Odisha Board of Secondary Education',
  'Assam Higher Secondary Education Council',
  'Goa Board of Secondary and Higher Secondary Education',
  'Chhattisgarh Board of Secondary Education',
  'Jharkhand Academic Council',
  'Himachal Pradesh Board of School Education',
  'Tripura Board of Secondary Education',
  'Manipur Board of Secondary Education',
  'Meghalaya Board of School Education',
  'Nagaland Board of School Education',
  'Mizoram Board of School Education',
  'Sikkim Board of Secondary Education',

  // 🌍 International Boards
  'IB (International Baccalaureate)',
  'Cambridge International (CAIE)',
  'Edexcel (Pearson)',
  'IGCSE (International General Certificate of Secondary Education)',
  'OxfordAQA International GCSE',

  // Others
  'Open School / Homeschooling',
  'Other',
];

export { schoolBoards as boards };

export const universities = [
  // 🇮🇳 Central & National Level
  'University of Delhi',
  'Jawaharlal Nehru University (JNU)',
  'Banaras Hindu University (BHU)',
  'Aligarh Muslim University (AMU)',
  'Jamia Millia Islamia (JMI)',
  'IGNOU (Indira Gandhi National Open University)',
  'IIT Delhi',
  'IIT Bombay',
  'IIT Madras',
  'IIT Kanpur',
  'IIT Kharagpur',
  'NIT Trichy',
  'NIT Surathkal',
  'BITS Pilani',
  'AIIMS (All India Institute of Medical Sciences)',
  'IIM Ahmedabad',
  'IIM Bangalore',
  'IIM Calcutta',
  'Tata Institute of Social Sciences (TISS)',
  'Indian Institute of Science (IISc)',

  // 🏛 State Universities
  'Anna University (Tamil Nadu)',
  'Madras University (Tamil Nadu)',
  'Bharathiar University (Tamil Nadu)',
  'Kerala University (Kerala)',
  'MG University (Kerala)',
  'University of Calicut (Kerala)',
  'Osmania University (Telangana)',
  'Kakatiya University (Telangana)',
  'Andhra University (Andhra Pradesh)',
  'SV University (Andhra Pradesh)',
  'Bangalore University (Karnataka)',
  'Mysore University (Karnataka)',
  'Mangalore University (Karnataka)',
  'University of Mumbai (Maharashtra)',
  'Pune University (Savitribai Phule Pune University)',
  'Shivaji University (Maharashtra)',
  'Gujarat University (Gujarat)',
  'MS University (Baroda, Gujarat)',
  'University of Rajasthan (Rajasthan)',
  'Punjab University (Chandigarh)',
  'Guru Nanak Dev University (Amritsar)',
  'Patna University (Bihar)',
  'Lucknow University (Uttar Pradesh)',
  'Allahabad University (Uttar Pradesh)',
  'Dr. Ram Manohar Lohia Avadh University (Uttar Pradesh)',
  'Calcutta University (West Bengal)',
  'Jadavpur University (West Bengal)',
  'North Bengal University (West Bengal)',

  // 🏫 Deemed & Private Universities
  'VIT University (Vellore Institute of Technology)',
  'SRM Institute of Science and Technology',
  'Amity University',
  'Lovely Professional University (LPU)',
  'Chandigarh University',
  'Christ University (Bengaluru)',
  'Symbiosis International University (Pune)',
  'Manipal Academy of Higher Education',
  'Sathyabama Institute of Science and Technology',
  'Bharath Institute of Higher Education and Research',
  'SASTRA University (Thanjavur)',
  'Hindustan Institute of Technology and Science',
  'KIIT University (Bhubaneswar)',
  'Graphic Era University (Dehradun)',
  'SR University (Warangal)',

  // 🎓 Medical & Law Colleges
  'Madras Medical College (Chennai)',
  'Stanley Medical College (Chennai)',
  'Christian Medical College (Vellore)',
  'JIPMER (Puducherry)',
  'AFMC (Armed Forces Medical College, Pune)',
  'National Law University (Delhi)',
  'National Law School of India University (Bangalore)',
  'Government Law College (Mumbai)',

  // 🎓 Teacher & Polytechnic Colleges
  'DIET (District Institute of Education and Training)',
  'Government Polytechnic College',
  'Private Polytechnic College',
  'Teacher Education College',

  // 🏫 Others
  'Government Arts College',
  'Government Engineering College',
  'Private Arts & Science College',
  'Community College',
  'Other',
];


// Courses (static, as no free API available)
export const schoolCourses = [
  'Science (Physics, Chemistry, Math)',
  'Science - Bio (Biology, Chemistry, Physics)',
  'Science - Maths (Physics, Chemistry, Maths)',
  'Science - CS / IT (Computer Science, Physics, Maths)',
  'Commerce (Accountancy, Business Studies, Economics)',
  'Commerce with Maths',
  'Arts / Humanities (History, Political Science, Sociology, Psychology)',
  'Arts with Economics',
  'Vocational / Skill-based Streams',
]

export const courses = [
 // 🧩 B.E. (Bachelor of Engineering) Courses
  'BE Computer Science Engineering',
  'BE Information Technology',
  'BE Electronics & Communication Engineering',
  'BE Electrical & Electronics Engineering',
  'BE Mechanical Engineering',
  'BE Civil Engineering',
  'BE Chemical Engineering',
  'BE Aerospace Engineering',
  'BE Automobile Engineering',
  'BE Biomedical Engineering',
  'BE Industrial Engineering',
  'BE Environmental Engineering',
  'BE Petroleum Engineering',
  'BE Biotechnology Engineering',
  'BE Metallurgical Engineering',
  'BE Mining Engineering',
  'BE Marine Engineering',
  'BE Robotics Engineering',
  'BE Mechatronics Engineering',
  'BE Nanotechnology Engineering',
  'BE Artificial Intelligence & Machine Learning',
  'BE Data Science & Engineering',
  'BE Cybersecurity Engineering',
  'BE Software Engineering',
  'BE Electronics & Instrumentation Engineering',
  'BE Computer Engineering with AI & ML',
  'BE Structural Engineering',
  'BE Automation & Control Engineering',
  'BE Power Systems Engineering',
  'BE Communication Systems Engineering',
  'BE Textile Engineering',
  'BE Agricultural Engineering',
  'BE Marine & Ocean Engineering',
  'BE Industrial Automation',
  'BE Fire & Safety Engineering',
  'BE Marine Logistics & Shipping',
  'BE Production Engineering',

  // ⚙️ M.E. (Master of Engineering) Courses
  'ME Computer Science Engineering',
  'ME Information Technology',
  'ME Electronics & Communication Engineering',
  'ME Electrical & Electronics Engineering',
  'ME Mechanical Engineering',
  'ME Civil Engineering',
  'ME Chemical Engineering',
  'ME Aerospace Engineering',
  'ME Automobile Engineering',
  'ME Biomedical Engineering',
  'ME Industrial Engineering',
  'ME Environmental Engineering',
  'ME Petroleum Engineering',
  'ME Biotechnology Engineering',
  'ME Metallurgical Engineering',
  'ME Mining Engineering',
  'ME Marine Engineering',
  'ME Robotics Engineering',
  'ME Mechatronics Engineering',
  'ME Nanotechnology Engineering',
  'ME Artificial Intelligence & Machine Learning',
  'ME Data Science & Engineering',
  'ME Cybersecurity Engineering',
  'ME Software Engineering',
  'ME Electronics & Instrumentation Engineering',
  'ME Computer Engineering with AI & ML',
  'ME Structural Engineering',
  'ME Automation & Control Engineering',
  'ME Power Systems Engineering',
  'ME Communication Systems Engineering',
  'ME Textile Engineering',
  'ME Agricultural Engineering',
  'ME Marine & Ocean Engineering',
  'ME Industrial Automation',
  'ME Fire & Safety Engineering',
  'ME Marine Logistics & Shipping',
  'ME Production Engineering',

  // 💻 SCIENCE & IT
  'BSc Physics',
  'BSc Chemistry',
  'BSc Mathematics',
  'BSc Biology',
  'BSc Computer Science',
  'BSc Biotechnology',
  'BSc Environmental Science',
  'BSc Geology',
  'BSc Statistics',
  'BCA (Bachelor of Computer Applications)',
  'MSc Physics',
  'MSc Chemistry',
  'MSc Mathematics',
  'MSc Computer Science',
  'MSc Biotechnology',
  'MSc Environmental Science',
  'MCA (Master of Computer Applications)',
  'Artificial Intelligence & Machine Learning',
  'Data Analytics / Big Data',
  'Cloud Computing',
  'Blockchain Technology',
  'Internet of Things (IoT)',
  'Game Development / Animation Technology',

  // 🏥 MEDICAL & HEALTH SCIENCES
  'MBBS (Bachelor of Medicine & Surgery)',
  'BDS (Dental Surgery)',
  'BPT (Physiotherapy)',
  'BSc Nursing',
  'BPharm (Pharmacy)',
  'MPharm (Pharmacy)',
  'MD (Doctor of Medicine)',
  'MS (Master of Surgery)',
  'MPT (Master in Physiotherapy)',
  'Master of Public Health (MPH)',
  'Allied Health Sciences',
  'Occupational Therapy',
  'Ayurveda / Homeopathy / Unani',
  'Medical Laboratory Technology (MLT)',
  'Radiology / Imaging Technology',
  'Optometry',
  'Nutrition & Dietetics',

  // 💼 COMMERCE & MANAGEMENT
  'BCom (Bachelor of Commerce)',
  'MCom (Master of Commerce)',
  'BBA (Bachelor of Business Administration)',
  'MBA (Master of Business Administration)',
  'Finance / Accounting / Economics',
  'Human Resource Management (HRM)',
  'Marketing Management',
  'Business Analytics',
  'Supply Chain Management',
  'International Business',
  'Entrepreneurship',
  'Hospital Administration',
  'Banking & Insurance',
  'E-Commerce Management',
  'Digital Marketing',

  // ⚖️ LAW
  'LLB (Bachelor of Law)',
  'LLM (Master of Law)',
  'Corporate Law',
  'Criminal Law',
  'International Law',
  'Cyber Law / IT Law',
  'Environmental Law',
  'Intellectual Property Law',

  // 🎭 ARTS & HUMANITIES
  'BA History',
  'BA Political Science',
  'BA Sociology',
  'BA Psychology',
  'BA English Literature',
  'BA Journalism & Mass Communication',
  'BA Philosophy / Ethics',
  'BA Fine Arts / Performing Arts',
  'BSW (Bachelor of Social Work)',
  'MSW (Master of Social Work)',
  'Liberal Arts',
  'Foreign Languages',
  'Cultural Studies',
  'Public Administration',
  'Education / BEd / MEd',

  // 🎨 DESIGN & ARCHITECTURE
  'BArch (Architecture)',
  'MArch (Architecture)',
  'Interior Design',
  'Fashion Design',
  'Graphic Design',
  'Animation & VFX',
  'UI/UX Design',
  'Industrial Design',
  'Product Design',
  'Landscape Architecture',
  'Game Design',
  'Textile Design',

  // ✈️ OTHERS / VOCATIONAL
  'Hotel Management (BHM / MHM)',
  'Tourism & Travel Management',
  'Agriculture Science',
  'Veterinary Science',
  'Food Technology / Nutrition',
  'Sports Science / Physical Education',
  'Event Management',
  'Hospitality & Airline Management',
  'Media & Communication',
  'Fire & Safety Engineering',
  'Logistics & Shipping Management',
  'Aviation Management',
  'Marine Logistics',
  'Other',
];


// Degree Types (static)
export const degreeTypes = [
  "Diploma",
  "Bachelor's",
  "Master's",
  "Doctorate",
  "Certificate",
  "Other",
];

// Institutes (static, can be extended)
export const institutes = [
  'IIT',
  'NIT',
  'BITS',
  'AIIMS',
  'IIM',
  'Local College',
  'School',
  'Other',
];

// Fetch countries from a free API
export const fetchCountries = async () => {
  const res = await axios.get('https://restcountries.com/v3.1/all');
  return res.data.map(c => ({ name: c.name.common, code: c.cca2 }));
};

// Fetch states/provinces for a country from a free API
export const fetchStates = async (country = 'India') => {
  const res = await axios.post('https://countriesnow.space/api/v0.1/countries/states', {
    country,
  });
  if (res.data && res.data.data && Array.isArray(res.data.data.states)) {
    return res.data.data.states.map((s) => s.name);
  }
  return [];
};

// Normalize city names by stripping diacritics and trimming whitespace
const normalizeCityName = (name) => {
  if (!name) return "";
  if (typeof name.normalize === "function") {
    return name
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }
  return name.replace(/\s+/g, " ").trim();
};

// Fetch cities for a country (and optional state) from a free API
export const fetchCities = async (country = 'India', state) => {
  if (!country) return [];

  try {
    if (state) {
      const res = await axios.post('https://countriesnow.space/api/v0.1/countries/state/cities', {
        country,
        state,
      });
      if (res.data && res.data.data) {
        return res.data.data
          .map(normalizeCityName)
          .filter((name) => name && name.length);
      }
      return [];
    }

    const res = await axios.post('https://countriesnow.space/api/v0.1/countries/cities', {
      country,
    });
    if (res.data && res.data.data) {
      return res.data.data
        .map(normalizeCityName)
        .filter((name) => name && name.length);
    }
    return [];
  } catch (error) {
    console.error('Error fetching cities:', error);
    return [];
  }
};
